import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { LocationResponse } from '@/features/location/types';

type UseLocationOptions = {
  page?: number;
  perPage?: number;
};
export const getAllLocations = ({
  page,
  perPage
}: UseLocationOptions = {}): Promise<LocationResponse> => {
  return axios.get(`/business/locations/prefill/all`, {
    params: { page, perPage },
  });
};

export const useGetAllLocations = (config: UseLocationOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getAllLocations,
  });
};
